export default {
  UPDATE_STAFF_STATE: Symbol('UPDATE_STAFF_STATE'),
  STAFF_LIST: Symbol('STAFF_LIST'),
  STAFF_CREATE: Symbol('STAFF_CREATE'),
  STAFF_UPDATE: Symbol('STAFF_UPDATE'),
  STAFF_DELETE: Symbol('STAFF_DELETE'),
  STAFF_DETAIL: Symbol('STAFF_DETAIL'),
};
